import React, { createContext, useContext, useState } from "react";

const PipelineContext = createContext(null);

export function PipelineProvider({ children }) {
  const [mode, setMode]       = useState("pipeline");
  const [expanded, setExpanded] = useState(false);
  const [running, setRunning] = useState(false);
  const [steps, setSteps]     = useState(null);
  const [result, setResult]   = useState(null);
  const [rangeFrom, setRangeFrom] = useState("");
  const [rangeTo, setRangeTo]     = useState("");
  const [range, setRange]     = useState({ status: "idle", result: null, error: null });
  const [lastSync, setLastSync] = useState(null);

  return (
    <PipelineContext.Provider value={{
      mode, setMode,
      expanded, setExpanded,
      running, setRunning,
      steps, setSteps,
      result, setResult,
      rangeFrom, setRangeFrom,
      rangeTo, setRangeTo,
      range, setRange,
      lastSync, setLastSync,
    }}>
      {children}
    </PipelineContext.Provider>
  );
}

export function usePipeline() {
  return useContext(PipelineContext);
}
